import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import Button from '../../../../../Button';
import ThumbRemove from '../../../../Helper/ThumbRemove';

import s from './StackOverlay.scss';

export interface Props {
  deviation: PapiDeviation;
  url?: string;
  className?: string;
  biData?: BiEvent;
  onRemove?: () => void;
  onClick?: () => void;
}

const StackOverlay: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  className,
  url,
  biData,
  onClick,
  onRemove,
}) => {
  const { t } = useTranslation();
  return (
    <ThemeOverride theme={ThemeOptions.DARK} className={classnames(s['root'], className)}>
      <Button
        className={s['button']}
        view="b14"
        fullWidth={false}
        height="medium"
        href={url}
        onClick={onClick}
        isFakeButton={!url && !onClick}
        biData={biData}
      >
        {t('deviationview.overlay.stack.button')}
      </Button>
      {onRemove && (
        <ThumbRemove deviation={deviation} onRemove={onRemove} className={s['remove']} />
      )}
    </ThemeOverride>
  );
};
StackOverlay.displayName = 'StackOverlay';

export default StackOverlay;
